import { Directive, ElementRef, EventEmitter, HostListener, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SearchService } from '../search/services/search.service';

@Directive({
  selector: '[overflow-hide]'
})
export class OverflowHideDirective implements OnInit, OnDestroy {
  @Output() callbackFn = new EventEmitter<boolean>();
  
  private resizeObserver!: ResizeObserver;
  private mutationObserver!: MutationObserver;
  private searchServiceSub!: Subscription;
  private rafId: number | null = null;
  private lastWidth = 0;

  constructor(
    private el: ElementRef,
    private zone: NgZone,
    private searchService: SearchService
  ) {}

  ngOnInit() {
    this.setupObservers();
    this.scheduleCheck();
    
    this.searchServiceSub = this.searchService.broadcastEvent.subscribe(args => {
      if (args.type === 'userTriggeredCriteriaUpdate' || args.type === 'searchEnded') {
        this.scheduleCheck(false);
        if (args.type === 'searchEnded') {
          setTimeout(() => this.scheduleCheck(false), 1500);
        }
      }
    });
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    this.searchServiceSub?.unsubscribe();
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  private setupObservers() {
    this.zone.runOutsideAngular(() => {
      // 1. ResizeObserver with debouncing
      this.resizeObserver = new ResizeObserver(() => {
        this.scheduleCheck();
      });
      this.resizeObserver.observe(this.el.nativeElement.parentElement);

      // 2. MutationObserver with targeted observations
      this.mutationObserver = new MutationObserver((mutations) => {
        const needsCheck = mutations.some(m => 
          m.type === 'attributes' || 
          m.addedNodes.length > 0 || 
          m.removedNodes.length > 0
        );
        if (needsCheck) this.scheduleCheck();
      });
      
      this.mutationObserver.observe(this.el.nativeElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    });
  }

  private scheduleCheck(isResize:boolean = true) {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.rafId = requestAnimationFrame(() => {
      this.checkOverflow(isResize);
      this.rafId = null;
    });
  }

  private checkOverflow(isResize:boolean = true) {
    const container = this.el.nativeElement;
    const currentWidth = container.offsetWidth;
    
    // Skip if width hasn't changed significantly (±5px threshold)
    if (Math.abs(currentWidth - this.lastWidth) < 40) return;
    this.lastWidth = currentWidth;

    const children = container.querySelector('.critChildren');
    if (!isResize && !this.isChildrenVisible(container)){
		return;
	}
	let isHidden: boolean = children.classList.contains('hide');
    let totalWidth = 0;
    Array.from(children.children as HTMLCollectionOf<HTMLElement>).forEach(child => {
      if (!child.classList.contains('btn-group')) {
        const style = window.getComputedStyle(child);
        totalWidth += (isHidden? this.getElementWidth(child):child.offsetWidth) + 
          parseFloat(style.marginLeft) + 
          parseFloat(style.marginRight);
      }
    });
    const isOverflowed = totalWidth > container.offsetWidth;
   	//console.log(">>>>>>>>>>>>>totalWidth: "+totalWidth+" container.offsetWidth:"+container.offsetWidth+" isOverflowed: "+isOverflowed);
    this.zone.run(() => this.callbackFn.emit(isOverflowed));
  }
  private isChildrenVisible(container: HTMLElement): boolean{
	const children = container.querySelector('.critChildren');
    if (!children ){
		console.log("children is undefined");
		return false;
	}
	if (children.classList.contains('hide')){
		console.log("children is hidden");
		this.zone.run(() => this.callbackFn.emit(true));
		return false;
	}  
	return true;
  }
  
 private getElementWidth(el :HTMLElement): number {
	 if(el?.textContent){
		 return el.textContent.length * 7.5;
	 }
	 return 0; 
  }
  
  @HostListener('window:resize')
  onWindowResize() {
    this.scheduleCheck();
  }
}